import React from 'react';
import Card from '../components/card/Card';
import Hero from '../components/hero/Hero';
import SectionOne from '../components/section-one/SectionOne';
import SectionTwo from '../components/section-two/SectionTwo';
import SectionThree from '../components/section-three/SectionThree';
import image from '../assets/website-pix.png'
import './home.css';
import Slider from "react-slick";
import quote from '../assets/review/quote.png';
import ill from '../assets/Illustration.svg'
const data = [{
    'name':'Ovie',
    'city':'Lagos',
    'review': 'Coding class has been fun for my children. They are always unhappy when the class comes to an end. They remain on scratch for hours after class ends. The level of concentration is unimaginable. The teaching style is commendable. I recommend this class for every child.'
    },
    {
        'name': 'Simi',
        'city': 'Canada',
        'review': 'I like coding and it has been a big entertainment during covid. Coding class is 2 hours and I usually play lots of games on the iPad on Saturday. I think coding is a perfect idea. Thank you.'
    },
    {
        'name': 'Tope',
        'city': 'Canada',
        'review': 'My daughter absolutely loves the coding class !!! She looks forward to the weekend classes. She has her laptop set up one hour ahead of time waiting for kick off. The classes are very engaging and interesting at the same time. Coding brings out the creativity in her.'
    },
    {
        'name': 'Damilola',
        'city': 'Dubai',
        'review': `We got the referral from a friend. I have never met the tutor but from day one she handled Daniel as though she'd known him all his life. There is something that Daniel was consistent in doing. never wanting to miss any class. great work Charis Coding Club!
        `
    },
    {
        'name': 'Olusina',
        'city': 'Lagos',
        'review': `I have requested that this program be run all year round till my son becomes a guru...
        My intention was to have something to keep him busy but this is beyond that. His creative and reasoning ability has greatly improved and he is always excited about coding.
        `
    },
    {
        'name': 'Omolara',
        'city': 'Lagos',
        'review': `At the beginning the boys didn't want to be a part of the scratch class. However, as the classes progressed, they found it very interesting, especially because they found that they could create their own games! What a Joy! Indeed, this is a very valuable contribution to raising the next generation of IT Savvy humans!`
    },
    {
        'name': 'Kiki',
        'city': 'Lagos',
        'review': 'Mide thoroughly enjoyed the class! The excitement on her face when she starts and finishes a task is always encouraging and she always boasts about it. The teacher is hands on and all about making the students thoroughly understand. The classes were nice. The program is highly recommendable for the kids.'
    },
    {
        'name': 'Dr. Eunice',
        'city': 'Benin-city',
        'review': 'A friend told me about Charis coding classes which would be held online. The classes were very interesting and they learnt a lot within a short period. They are now able to create games, cartoons. I recommend coding classes for every child  '
    },
    {
        'name': 'Kayode',
        'city': 'Bauchi',
        'review': `It's what I've always looked forward to: a coding spring board for kids!. I will definitely recommend her over and over again. If your kids are computer savvy already, Charis Coding Club will surely put them on higher steads of ingenuity.
         `
    },


]


function Home() {



    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 10000,
        autoplaySpeed: 5000,
        cssEase: "linear"
      };
    const mobile = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 10000,
        autoplaySpeed: 5000,
        cssEase: "linear"
      };


    return (
        <div className='home__main'>
                <Hero/>
            <div className="home__container">
                <SectionOne/>
            <div data-aos='fade-down' className="home__image">
                <img src={image} alt="" />
            </div>
                <SectionTwo />
            </div>
            <div className="home__cards">
                <div className="home__card">
                <div data-aos='zoom-out-down'  data-aos-duration='500' className="card__home">
                    <Card 
                    text='Students will be introduced to scratch programming'
                    title='Scratch'
                    />
                </div>
                <div data-aos='zoom-out-down'  data-aos-duration='1500' className="card__home">
               
                    <Card 
                    text='This introduces to the basics of 3D Animation'
                    title='3D Animation'
                    />
                </div>
                <div data-aos='zoom-out-down'  data-aos-duration='2500' className="card__home">

                    <Card 
                    text='Solve complex logic and build fun games with Python'
                    title='Python'
                    />

                </div>
                <div data-aos='zoom-out-down' data-aos-duration='3000'  className="card__home">

                    <Card 
                    text='Create awesome web, mobile and desktop interfaces'
                    title='HTML,CSS & JS'
                    />
                </div>
                </div>

            </div>
         

            <div className="carousel"> 
                <div className="home_carousel">
            <h1>What Parents say about us</h1>
                    <Slider {...settings}>
                        { data.map(mydata => (

                            <div className="carousel__body">
                                <img src={quote} alt="" />
                                    <div className="carousel__name">
                                        <h4>{mydata.name}</h4>
                                        <i><p>{mydata.city}</p></i>
                                        <p><span>@ {mydata.name} </span>{mydata.review}</p>
                                    </div>
                            </div>
                             ))
                        }
                        
                    
                        
                        
                    </Slider>
                </div>
                <div className="mobile_carousel">
                   <h1>What Parents say about us</h1>

                    <Slider {...mobile}>
                        { data.map(mydata => (
                            <div className="carousel__body">
                                <img src={quote} alt="" />
                                    <div className="carousel__name">
                                        <h4>{mydata.name}</h4>
                                        <i><p>{mydata.city}</p></i>
                                        <p><span>@ {mydata.name} </span>{mydata.review}</p>
                                    </div>
                            </div>
                            ))
                        }   
                            
                    </Slider>
                </div>
            </div>
            <div className="full__projects">

<div className="head__two proj">Some of our Projects <img src={ill} alt="" /></div>
<div className="projects">
    <div className="myproject">
        <div className="project__title">
            <h4>Take the apple</h4>
        </div>
    <iframe src="https://scratch.mit.edu/projects/432128369/embed" allowtransparency="true" width="485" height="402" frameborder="0" scrolling="no" allowfullscreen></iframe>
    <div className="project__title">
                <p className='paragraph'>Instruction: Use the left and right arrow keys to catch apples while dodging the sticks.</p>
        </div>
    
    </div>
    <div className="myproject">
        <div className="project__title">
                <h4>Ping pong</h4>
        </div>
    <iframe src="https://scratch.mit.edu/projects/415534125/embed" allowtransparency="true" width="485" height="402" frameborder="0" scrolling="no" allowfullscreen></iframe> 	
    <p className='paragraph'>Instruction: Use the mouse to control the paddle and play against the computer.</p>
    </div>
    <div className="myproject">
        <div className="project__title">
                <h4>Rock Blaster game</h4>
        </div>
        <iframe src="https://scratch.mit.edu/projects/466863362/embed" allowtransparency="true" width="485" height="402" frameborder="0" scrolling="no" allowfullscreen></iframe>
            <p className='paragraph'>Instruction: Use the up and down arrow keys to move the rocket and use the space bar to shoot.</p>
        </div>
        <div className="myproject">
            <div className="project__title">
                <h4>Ghost Chase</h4>
            </div>
        <iframe src="https://scratch.mit.edu/projects/608145304/embed" allowtransparency="true" width="485" height="402" frameborder="0" scrolling="no" allowfullscreen></iframe> 
        <p className='paragraph'>Instruction: Click on as many ghost as possible to score points.</p>
        </div>

</div>
<div className="projects">
</div>
</div>
            <div className="home__sectionThree">
                <div className="home__sectionThreeMain">
                    <SectionThree />
                </div>
            </div>
           
        </div>
    )
}

export default Home
